import { useCurrentOwnerType } from '@user';
import { OwnerTypePermissions } from '@permissions';
import { isAvailableByOwnerType } from '../utils';

export const useIsAvailableByOwnerType = (options: OwnerTypePermissions): boolean => {
  const currentOwnerType = useCurrentOwnerType();
  return isAvailableByOwnerType(currentOwnerType, options);
};
